export default "__VITE_ASSET__07baa994__"